module.exports = __webpack_public_path__ + "static/media/icona nuovo versamento.06c93df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icona nuovo versamento.png
// module id = 95
// module chunks = 0